/**
 * Alternative Facebook SDK Plugin - Using HTML Script Method
 * วิธีการแทนที่สำหรับการโหลด Facebook SDK แบบ traditional
 */

// Facebook SDK Configuration
const FACEBOOK_CONFIG = {
  appId: process.env.FACEBOOK_APP_ID || '',
  version: 'v18.0',
  locale: 'th_TH'
}

// HTML Script method for Facebook SDK
export const FacebookSDKScript = {
  /**
   * Generate Facebook SDK HTML script tag
   */
  generateScript() {
    return `
      <script>
        window.fbAsyncInit = function() {
          FB.init({
            appId      : '${FACEBOOK_CONFIG.appId}',
            cookie     : true,
            xfbml      : true,
            version    : '${FACEBOOK_CONFIG.version}'
          });
          
          FB.AppEvents.logPageView();
          
          console.log('🟢 Facebook SDK initialized via HTML script');
        };

        (function(d, s, id){
           var js, fjs = d.getElementsByTagName(s)[0];
           if (d.getElementById(id)) {return;}
           js = d.createElement(s); js.id = id;
           js.src = "https://connect.facebook.net/${FACEBOOK_CONFIG.locale}/sdk.js";
           fjs.parentNode.insertBefore(js, fjs);
         }(document, 'script', 'facebook-jssdk'));
      </script>
    `
  },

  /**
   * Nuxt head configuration for Facebook SDK
   */
  nuxtHeadConfig() {
    return {
      script: [
        {
          innerHTML: `
            window.fbAsyncInit = function() {
              FB.init({
                appId      : '${FACEBOOK_CONFIG.appId}',
                cookie     : true,
                xfbml      : true,
                version    : '${FACEBOOK_CONFIG.version}'
              });
              
              FB.AppEvents.logPageView();
              
              console.log('🟢 Facebook SDK initialized via Nuxt head');
            };

            (function(d, s, id){
               var js, fjs = d.getElementsByTagName(s)[0];
               if (d.getElementById(id)) {return;}
               js = d.createElement(s); js.id = id;
               js.src = "https://connect.facebook.net/${FACEBOOK_CONFIG.locale}/sdk.js";
               fjs.parentNode.insertBefore(js, fjs);
             }(document, 'script', 'facebook-jssdk'));
          `,
          type: 'text/javascript',
          body: true // Add to body instead of head
        }
      ]
    }
  },

  /**
   * Vue composable for Facebook SDK
   */
  useFacebookSDK() {
    const isLoaded = ref(false)
    const error = ref(null)

    const waitForSDK = () => {
      return new Promise((resolve, reject) => {
        let attempts = 0
        const maxAttempts = 50 // 5 seconds with 100ms intervals
        
        const checkSDK = () => {
          attempts++
          
          if (window.FB) {
            isLoaded.value = true
            resolve(window.FB)
            return
          }
          
          if (attempts >= maxAttempts) {
            error.value = 'Facebook SDK failed to load'
            reject(new Error('Facebook SDK timeout'))
            return
          }
          
          setTimeout(checkSDK, 100)
        }
        
        checkSDK()
      })
    }

    onMounted(async () => {
      try {
        await waitForSDK()
        console.log('🟢 Facebook SDK ready for use')
      } catch (err) {
        console.error('🔴 Facebook SDK loading error:', err)
        error.value = err.message
      }
    })

    return {
      isLoaded: readonly(isLoaded),
      error: readonly(error),
      waitForSDK
    }
  }
}

// Export for use in different contexts
export default FacebookSDKScript